import React, { Component } from 'react';

import ErrorBoundary from './ErrorBoundary';

class Conteudo extends Component {
  render() {
    let children = this.props.children;
    if (!children || (children instanceof Array && !children.length)) children = null;

    return (
      <div className="conteudo">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="corpo-conteudo">
                <ErrorBoundary>
                  {children}
                </ErrorBoundary>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Conteudo;



// WEBPACK FOOTER //
// ./src/Conteudo.js